import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgCaption01 = (props) => {
  return <LSRgCaption01Wrapper {...props} />;
};

export default LSRgCaption01;

const LSRgCaption01Wrapper = styled(LineSeedKrRg)`
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: -0.3px;

  color: #222222;
`;
